module.exports = __webpack_public_path__ + "static/media/finals.2660ecbf.svg";